<template>
	<JBox>
		<CFormInput componentName="JInputText" name="name" label="Name your app" v-model="form.appName" class="s-mb-6" />

		<!-- TODO: this should be decomposed based on / and split into host and regex pattern so that we restrict what host can be selected -->
		<CFormInput
			componentName="JInputText"
			name="url"
			label="URL including regex pattern"
			v-model="form.urlRouting.regexPattern"
			class="s-mb-6"
		/>

		<CFormInput componentName="JInputText" name="email" label="Login invitation email from" v-model="form.email" class="s-mb-6" />

		<CFormInput
			componentName="JInputText"
			name="emailSenderName"
			label="Login invitation email name"
			v-model="form.emailSenderName"
			class="s-mb-6"
		/>

		<!-- <JFlex>
			<JBox class="s-w-1/2 s-pr-2">
				<CFormInput :type="injections.HostPicker" name="domain" label="Domain" v-model="form.host" />
				<JButton variant="default-light-xs" @click="showCreateHost = !showCreateHost">+ Add new domain</JButton>
			</JBox>
			<JBox class="s-w-1/2 s-pl-2">
				<CFormInput type="JInputText" name="url" label="Route Regex Pattern" v-model="form.regex" class="s-mb-6" />
			</JBox>
		</JFlex> -->

		<JFlex class="s-justify-between s-items-center s-mt-10">
			<JButton @click="updateApp" variant="default-light">Update</JButton>
			<JButton @click="$emit('cancel')" variant="white">Cancel</JButton>
			<JSpinner class="s-ml-2" type="dots" v-if="isUpdateLoading" />
		</JFlex>
		<JBox v-if="updateError" class="s-text-center s-mt-4 s-text-red-600">
			{{ updateError }}
		</JBox>

		<!-- Create Host -->
		<Portal to="layer1">
			<CModal :isVisible="showCreateHost" variant="default-small">
				<JBox class="s-p-8">
					<HostCreator @cancel="showCreateHost = false" @created="showCreateHost = false" />
				</JBox>
			</CModal>
		</Portal>
	</JBox>
</template>

<script>
import HostPicker from "./HostPicker"
import HostCreator from "./HostCreator"

export default {
	components: { HostCreator },
	data() {
		return {
			form: {
				appId: null,
				appName: null,
				email: "",
				emailSenderName: "",
				urlRouting: {
					regexPattern: ""
				}
			},
			isUpdateLoading: false,
			updateError: "",

			// Create host
			showCreateHost: false,

			injections: {
				HostPicker
			}
		}
	},

	methods: {
		async updateApp() {
			if (this.isUpdateLoading) return // prevent multiple submit
			this.updateError = "" // reset

			this.isUpdateLoading = true
			const { isSuccess, res } = await this.$store.dispatch("apps/updateApp", { ...this.form })
			this.isUpdateLoading = false

			if (!isSuccess) {
				// TODO: localize
				this.updateError =
					res?.data?.updateApp?.errors?.[0] ?? "Oops, there was an error when updating your app. Please try again."
				return
			}

			this.$emit("updated", { appId: this.form.appId })
		}
	},

	watch: {
		"$store.state.apps.detail": {
			handler(val) {
				const newVal = { ...val }

				if (!newVal?.urlRouting?.regexPattern) newVal.urlRouting = { regexPattern: "" } // check for empty urlRouting
				this.form = { ...newVal }
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
